module.exports = __webpack_public_path__ + "img/expodecor_avignon_pavement.f809c6a1.jpg";